<span role="button"
class="animate__animated animate__bounceIn font-5 d-flex align-items-center clip3 position-relative me-2 user-card fw-normal primary-text-100 primary-border corner p-2">
            
    @if(data(); as data)
    {        
        <presenter [data]="data" key="breadcrumb-item" allowFallback="true" [finalFallbackTemplate]="fallbackTemplate" />            
    }
    <span class="material-icons-sharp font-5 ms-3">close</span>
</span>

<ng-template #fallbackTemplate let-data="data">
    {{data.name()}}
</ng-template>